import { RootState } from '@cp/src/store';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addComment } from '../../actions/CsaTicketingActions';
import { setTicketData } from '../../reducers/CsaTicketingSlice';
import { ICommentWidget, TicketAcitvityType, TicketStatus } from '../../types';
import CommentTextArea from './CommentTextArea';

const CommentWidget = (props: ICommentWidget) => {
  const { ticket } = props;
  const isEditingAllowed = [TicketStatus.TODO, TicketStatus.IN_PROGRESS].includes(ticket?.status);
  const activityLogs = ticket?.activityLogs || [];
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const commentRef = useRef<HTMLTextAreaElement>(null);
  const user = useSelector((state: RootState) => state?.common?.userData);
  const dispatch = useDispatch();

  const addCommentBtnHandler = () => {
    if (!comment) return;
    commentRef?.current?.blur();
    setIsLoading(true);
    const commentTrimmed = comment.trim();
    setComment('');
    addComment(
      ticket?.referenceId,
      { comment: commentTrimmed },
      () => {
        dispatch(
          setTicketData({
            ...ticket,
            activityLogs: [
              {
                type: TicketAcitvityType.COMMENT_ADDITION,
                activityBy: {
                  referenceId: user?.referenceId,
                  name: user?.name
                },
                activityAt: Date.now(),
                value: commentTrimmed
              },
              ...activityLogs
            ]
          })
        );
        setComment('');
      },
      () => {
        setIsLoading(false);
        commentRef.current?.focus();
      }
    );
  };

  return (
    <div className="flex-1 pb-4 pl-[10px]">
      <CommentTextArea
        ref={commentRef}
        value={comment}
        onChange={e => setComment(e.target.value)}
        onSend={addCommentBtnHandler}
        disabled={!isEditingAllowed || isLoading}
      />
    </div>
  );
};

export default CommentWidget;
